import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32ab86aa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "text-white bg-primary p-2 footer font-weight-bold" };
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const APPTITLE = process.env.VUE_APP_TITLE || '';
        const store = useStore();
        const appTitle = APPTITLE;
        const version = ref('loading...');
        const loadConfig = async () => {
            try {
                const response = await fetch('/config/app-config.json');
                if (!response.ok) {
                    version.value = 'dev';
                    return;
                }
                const config = await response.json();
                version.value =
                    config &&
                        typeof config === 'object' &&
                        'version' in config &&
                        typeof config.version === 'string'
                        ? config.version
                        : 'dev';
            }
            catch (error) {
                const message = error instanceof Error ? error.message : String(error);
                console.warn('Failed to load runtime config, using fallback:', message);
                version.value = 'dev';
            }
        };
        const showPrivacyPolicyModal = () => {
            void store.dispatch('auth/updateUserAgreementsModals', { showPrivacy: true });
        };
        const showTermsAndConitionsModal = () => {
            void store.dispatch('auth/updateUserAgreementsModals', { showTerms: true });
        };
        onMounted(() => {
            void loadConfig();
        });
        return (_ctx, _cache) => {
            const _component_b_col = _resolveComponent("b-col");
            const _component_b_row = _resolveComponent("b-row");
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createVNode(_component_b_row, { class: "mx-0" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_col, {
                            cols: "4",
                            class: "pl-0"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", {
                                    class: "modal-link",
                                    onClick: showTermsAndConitionsModal
                                }, " Terms & Conditions | "),
                                _createElementVNode("span", {
                                    class: "modal-link",
                                    onClick: showPrivacyPolicyModal
                                }, " | Privacy Policy ")
                            ], undefined, true),
                            _: 1
                        }),
                        _createVNode(_component_b_col, {
                            cols: "4",
                            class: "text-center"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Transreport limited. All rights reserved. ")
                            ], undefined, true),
                            _: 1
                        }),
                        _createVNode(_component_b_col, {
                            cols: "4",
                            class: "text-right pr-0"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(appTitle)) + " v" + _toDisplayString(version.value), 1)
                            ], undefined, true),
                            _: 1
                        })
                    ], undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
